/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { getGroup } from '@g17eco/core';
import { useMemo } from 'react';
import { useAppSettings } from './useAppSettings';

interface RecommendedAddons {
  name: string;
  code: string;
  logo?: string;
}

export const useRecommendedAddons = () => {
  const settings = useAppSettings()

  return useMemo(() => {
    const addons = settings.overviewRecommendedAddons
    return addons.map(code => {
      const group = getGroup('standards-and-frameworks', code);
      return {
        name: group?.shortName ?? code,
        code: group?.code ?? code,
        logo: group?.src
      }
    }) as RecommendedAddons[]

  }, [settings])
}
